<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="部门">
                <el-select v-model="form.parent_id" placeholder="请选择" clearable @change="depParentChang">
                    <el-option label="顶级部门" :value="0" ></el-option>
                    <el-option v-for="(item, index) in dept_tree" :label="item.name" :value="item.dept_id" :key="index"> {{item.prefix}}{{item.name}} </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="部门名称" prop="name">
                <el-input v-model="form.name" placeholder="部门名称" clearable/>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {deptEdit, deptDetail, getListChildrenTree} from '@/api/education';

    export default {
        components: { },
        data() {
            return {
                title: '',
                form: {
                    dept_id: '',
                    name: '',
                    parent_id: 0,
                    company_id: 0,
                    status: 1,
                    sort: 1,
                    scene: 'add',
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入名称',
                        trigger: 'blur'
                    }]
                },
                dept_tree: [],
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if(!row.company_id){
                    this.$message({message: '单位不存在', type: 'success'});
                    return false
                }
                this.form.company_id = row.company_id
                if (row.scene === 'add') {
                    if(row.parent_id > 0){
                        this.form.parent_id = row.parent_id
                    }
                    this.title = '添加部门'
                } else {
                    this.form.dept_id = row.dept_id
                    this.title = '编辑部门'
                    this.getDetail()
                }
                this.deptTree()
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.form.content = ''
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        deptEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            deptTree(){
                getListChildrenTree({company_id: this.form.company_id}).then((r)=>{
                    console.log(r.data)
                    this.dept_tree = r.data.list
                })
            },
            depParentChang(val){
                this.form.parent_id = val
            },
            getDetail(){
                deptDetail({id: this.form.dept_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/dept/dept/dept-edit.vue